export default {
	state: () => ({
		activeStep: 0,
		stepFinished: 0
	}),
	getters: {
		getHeyloActiveStep: (state) => {
			return state.activeStep;
		},
		getHeyloStepFinished: (state) => {
			return state.stepFinished;
		},
	},
	mutations: {
		setHeyloActiveStep: (state, activeStep) => {
			state.activeStep = activeStep
		},
		setHeyloStepFinished: (state, stepFinished) => {
			state.stepFinished = stepFinished
		},
	},
}
